import { Component, OnInit } from '@angular/core';
import { ValidationService } from '../validation.service';
import { HttpService } from '../http.service';
import { SnackbarService } from '../snackbar.service';
import { Router } from '@angular/router';
import { Messages } from '../constants/messages';
export interface NewPassword {
  password_token: string;
  password: string;
  confirmPassword: string;
}
@Component({
  selector: 'app-reset-password',
  templateUrl: './reset-password.component.html',
  styleUrls: ['./reset-password.component.scss']
})
export class ResetPasswordComponent implements OnInit {
  newData: NewPassword = {
    password_token: '',
    password: '',
    confirmPassword: ''
  };
  passwordStrengthPassedCheck = {
    minimumChars: false,
    oneSpecial: false,
    oneCapital: false,
    oneNumeric: false,
    overall: false
  };

  flag = false;
  component: any;
  messages = new Messages();
  constructor(private valid: ValidationService, private http: HttpService, private snackbar: SnackbarService, private route: Router) { }

  ngOnInit() {
    const token = this.route.url.substr(1).split('=');
    this.newData.password_token = token[1];
    const temp = this.route.url.substr(1).split('?');
    this.component = (temp[0] == 'forgot_password') ? 'Reset Password' : 'Set Password';
  }

  passwordStrengthChecker() {
    this.passwordStrengthPassedCheck.oneSpecial = new RegExp('(?=.*?[#?!@$%^&*-])').test(this.newData.password);
    this.passwordStrengthPassedCheck.oneCapital = new RegExp('(?=.*?[A-Z])').test(this.newData.password);
    this.passwordStrengthPassedCheck.oneNumeric = new RegExp('(?=.*?[0-9])').test(this.newData.password);
    this.passwordStrengthPassedCheck.minimumChars = this.newData.password.length >= 8;
    this.passwordStrengthPassedCheck.overall = new RegExp('^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9])(?=.*?[#?!@$%^&*-]).{8,}$').test(this.newData.password);

  }
  validtate(details) {
    if (!(this.valid.isEmpty(details.password)) && !(this.valid.isEmpty(details.confirmPassword))) {
      if ( (this.valid.isPass(details.password)) && (this.valid.isPass(details.confirmPassword))) {
        if (details.password !== details.confirmPassword) {
          this.snackbar.openSnackBar(this.messages.RESET_PASSWORD.VALIDATION.MATCH, '', 'err');
          return false;
        } else {
          return true;
        }
      } else {
        this.snackbar.openSnackBar(this.messages.RESET_PASSWORD.VALIDATION.PASSWORD_PROPERTES, '', 'err');
        return false;
      }
    } else {
      this.snackbar.openSnackBar(this.messages.RESET_PASSWORD.VALIDATION.PASSWORD, '', 'err');
      return false;
    }
  }
  submit() {
    const valid = this.validtate(this.newData);
    if (valid) {
      delete this.newData.confirmPassword;
      this.http.post('carrier_user/password/set', this.newData).subscribe(
        (data: any) => {
          if (data.statusCode === 200) {
            this.snackbar.openSnackBar(this.messages.RESET_PASSWORD.SUCCESS.PASSWORD, '');
            this.route.navigateByUrl('login');
            this.flag = true;
          }
        },
        (err: any) => {
          this.snackbar.openSnackBar(err.error.message, '', 'err');
        }
      );
    }
  }
}
